import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { ListingCard } from '../../../../components';
import { useDispatch } from 'react-redux';
import { fetchLatestListings } from '../../../LandingPage/LandingPage.duck';
import { useConfiguration } from '../../../../context/configurationContext';
import css from './SectionNewListings.module.css';

const SectionNewListings = () => {
    const [listings, setListings] = useState([]);
    const config = useConfiguration();
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchListings = async () => {
            try {
                const latestListings = await dispatch(fetchLatestListings(config));
                setListings(latestListings);
            } catch (error) {
                console.error("Error fetching latest listings:", error);
            }
        };

        fetchListings();
    }, [config, dispatch]);

    const scrollLeft = () => {
        const container = document.getElementById('scrollContainer');
        const itemWidth = container.firstChild.clientWidth;
        container.scrollBy({ left: -itemWidth, behavior: 'smooth' });
    };

    const scrollRight = () => {
        const container = document.getElementById('scrollContainer');
        const itemWidth = container.firstChild.clientWidth;
        container.scrollBy({ left: itemWidth, behavior: 'smooth' });
    };

    return (
        <section className={css.section}>
          <div className={css.centerCarousel}>
            <h2 className={css.title}>
                <FormattedMessage id="LandingPage.newListingsTitle" defaultMessage="New Listings" />
            </h2>
            <div className={css.carouselContainer}>
                <div className={css.carouselArrows}>
                    <button className={css.carouselArrowPrev} onClick={scrollLeft}>‹</button>
                    <button className={css.carouselArrowNext} onClick={scrollRight}>›</button>
                </div>
                <div
                    id="scrollContainer"
                    className={css.scrollContainer}
                >
                    {listings.map(listing => (
                        <div key={listing.id.uuid} className={css.listingItem}>
                            <ListingCard listing={listing} />
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </section>
    );
};

export default SectionNewListings;
